import React from 'react';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import { useAccess } from '../../hooks/useAccess';

/**
 * Shared "مسئول" filter for assignable admin lists.
 *
 * Emits the `assignee` query param the backend's utils/assignmentScope reads:
 *   ''           → default scope (regular admin: mine + unassigned; super admin: everything)
 *   'me'         → only mine
 *   'unassigned' → only unclaimed
 *
 * The option labels differ by role because the DEFAULT means different things:
 * for a regular admin it is already narrowed to their own work, so calling it
 * «همه» would be a lie. Super admins genuinely do see everything.
 */

export type AssigneeFilterValue = '' | 'me' | 'unassigned';

interface Props {
  value: AssigneeFilterValue;
  onChange: (v: AssigneeFilterValue) => void;
  /** Renders inside the shared `.filters-grid` layout when true (default). */
  grid?: boolean;
}

const AssigneeFilter: React.FC<Props> = ({ value, onChange, grid = true }) => {
  const { user } = useAccess();
  const defaultLabel = user.isSuperAdmin ? 'همه' : 'کارهای من و بدون مسئول';

  const select = (
    <select
      className="filter-field"
      value={value}
      onChange={(e) => onChange(e.target.value as AssigneeFilterValue)}
    >
      <option value="">{defaultLabel}</option>
      <option value="me">فقط کارهای من</option>
      <option value="unassigned">فقط بدون مسئول</option>
    </select>
  );

  if (!grid) return select;

  return (
    <div className="filter-group">
      <label className="filter-label">
        <PersonOutlineIcon fontSize="small" /> مسئول
      </label>
      {select}
    </div>
  );
};

export default AssigneeFilter;
